import { render, staticRenderFns } from "./NotificacioncontactoFormHeader.vue?vue&type=template&id=184ad30f"
import script from "./NotificacioncontactoFormHeader.vue?vue&type=script&lang=js"
export * from "./NotificacioncontactoFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports